<!-- manage-subscription-dialog.component.html -->
<h2 mat-dialog-title>Gestisci abbonamento</h2>

<mat-dialog-content>
  <p>Gestisci le impostazioni del tuo abbonamento</p>

  <form [formGroup]="subscriptionForm">
    <div class="d-flex justify-content-between align-items-center me-0 mb-2">
      <span>Rinnovo automatico</span>
      <span>
        <mat-slide-toggle
          formControlName="auto_renew"
          color="primary"
          class="mt-2 toggle-spacing"
          matTooltip="Disattiva il rinnovo automatico del tuo abbonamento."
          [matTooltipShowDelay]="showDelay.value"
          [matTooltipHideDelay]="hideDelay.value"
          (change)="onToggleChange($event)"
        >
        </mat-slide-toggle>
      </span>
    </div>
  </form>

  <button 
    mat-raised-button 
    (click)="openContractAttachment(data.organization.contract_file)"
    class = "mt-1 mb-3 w-100"
    >
  <mat-icon matChipAvatar>attach_file</mat-icon> 
    Vedi contratto firmato
  </button>

  <div *ngIf="isLoading" class="text-center mt-3">
    <mat-spinner diameter="30"></mat-spinner>
    <p class="mt-2">Aggiornamento in corso...</p>
  </div>

  <mat-divider></mat-divider>

  <p class="mt-3">Non trovi quello che cerchi? Contattaci:</p>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>La nostra mail</mat-label>
    <input
      matInput 
      [value]="helpEmail" 
      readonly
      #linkInput>
    <button 
      mat-icon-button 
      matSuffix 
      (click)="copyToClipboard()"
      [attr.aria-label]="'Copia link'">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Il nostro numero verde</mat-label>
    <input 
      matInput 
      [value]="helpNumber" 
      readonly
      #linkInput>
    <button 
      mat-icon-button 
      matSuffix 
      (click)="copyNumberToClipboard()"
      [attr.aria-label]="'Copia numero'">
      <mat-icon>content_copy</mat-icon>
    </button>
  </mat-form-field>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="isLoading">Indietro</button>
  <button 
    mat-raised-button 
    color="primary" 
    (click)="confirm()"
    [disabled]="isLoading || subscriptionForm.invalid"
  >
    <mat-icon>check</mat-icon>
    Salva
  </button>
</mat-dialog-actions>
